<template>
  <select
    class="form-control default no-options"
    :class="data.class"
    :required="data.required"
    :disabled="data.disabled"
    :value="getValue"
    @input="$emit('input', $event.target.value)"
    :key="data.options.length"
    :style="data.style"
  >
    <option :value="null">{{ data.valueDefault || 'Selecione' }}</option>
    <option :value="null" v-show="data.options.length === 0" disabled>Sem resultados...</option>
    <option
      v-for="option in data.options"
      :key="option.value"
      :value="option.value"
    >
      {{ option.text }}
    </option>
  </select>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
    },
    value: {
      required: true
    }
  },
  computed: {
    getValue () {
      if (this.value === undefined || this.value === '') return null
      else return this.value
    }
  }
};
</script>
<style scoped lang="scss">

</style>